export default __webpack_public_path__ + "static/media/caisse.58121d61.png";